import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Helmet } from 'react-helmet';
import { keyBy, find, get, cloneDeep } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ImagePlane from 'assets/images/plane-black.svg';
import helpers from 'utils/helpers';
import { getTransactionsRequest } from 'ducks/users';
import { confirmAdjustmentRequest } from 'ducks/shipments';
import PushUpDrawer from 'components/common/PushUpDrawer';
import TransactionReturnContent from './TransactionReturnContent';
import countries from 'data/countries';
import { TransactionCardTitle, StyledButton } from 'components/Styled';

// const ORDER_NORMAL = 0;
const ORDER_HOLD = 1;
class TransactionReturn extends Component {
  state = {
    uiLoaded: false,
    loading: false,
    drawerVisible: false
  };

  authentication = () => {
    if (this.props.user) {
      if (
        !this.props.transactions ||
        (this.props.location.state !== undefined &&
          this.props.location.state.reschedulePickupSuccess)
      ) {
        this.props.getTransactionsRequest({ user: this.props.user });
      } else {
        this.setState({
          uiLoaded: true
        });
      }
    } else if (this.props.user === false) {
      this.props.history.push(`${process.env.PUBLIC_URL}/login`);
    }
  };

  handleOriginExpand = () => {
    this.setState({
      originExpand: !this.state.originExpand
    });
  };

  handleDestinationExpand = () => {
    this.setState({
      destinationExpand: !this.state.destinationExpand
    });
  };

  handleSubmitClick = type => {
    this.setState({
      loading: true
    });

    const confirm = type === 'pay';
    const transaction =
      this.props.data ||
      find(this.props.transactions, {
        ref: this.props.match.params.ref
      });

    const shipment = get(transaction, 'shipments[0]') || {};

    this.props.confirmAdjustmentRequest({
      transactionRef: transaction.ref,
      shipmentRef: shipment.ref,
      confirm
    });
  };

  setDrawerVisible = () => {
    if (this.props.handleRefresh && this.state.drawerVisible)
      this.props.handleRefresh();
    this.setState({
      drawerVisible: !this.state.drawerVisible
    });
  };

  handleSuccessClick = () => {
    this.props.history.push({
      pathname: `${process.env.PUBLIC_URL}/account/orders/`
    });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.user !== this.props.user) {
      this.authentication();
    }

    if (
      !this.props.confirmAdjustmentSuccess &&
      !this.props.data &&
      prevProps.transactions !== this.props.transactions
    ) {
      const transaction =
        this.props.data ||
        find(this.props.transactions, {
          ref: this.props.match.params.ref
        });
      if (transaction.status !== 4) {
        this.props.history.push(
          `${process.env.PUBLIC_URL}/account/orders/${transaction.ref}`
        );
      }
      // const trackingNumber = get(transaction, 'shipments[0].trackingNumber');
      // window.dataLayer.push({
      //   event: 'Land Shipment Tracking Page',
      //   trackingNumber
      // });
    }

    if (prevProps.uiLoading && !this.props.uiLoading) {
      this.setState({
        uiLoaded: true
      });
    }

    if (
      prevProps.confirmAdjustmentLoading &&
      !this.props.confirmAdjustmentLoading &&
      !this.props.confirmAdjustmentSuccess
    ) {
      this.setState({
        loading: false
      });
    }

    if (
      !prevProps.confirmAdjustmentSuccess &&
      this.props.confirmAdjustmentSuccess
    ) {
      this.props.getTransactionsRequest({ user: this.props.user });
      return;
    }
    if (
      prevProps.confirmAdjustmentSuccess &&
      prevProps.transactions !== this.props.transactions
    ) {
      this.setState({
        loading: false
      });

      this.setState({
        drawerVisible: true
      });
    }
  }

  componentDidMount() {
    this.authentication();
  }

  render() {
    const TRANSACTION_HOLD = 4;
    // const SHIPMENT_HOLD = 2;

    const countriesData = keyBy(this.props.countries, 'alpha-2');
    let transaction = null;
    if (this.props.data) {
      transaction = cloneDeep(this.props.data);
    } else {
      transaction = find(this.props.transactions, {
        ref: this.props.match.params.ref
      });
    }

    const shipment = get(transaction, 'shipments[0]') || {};
    // const chargeDiff = get(transaction, 'chargeDifference') || 0;

    shipment.finalTotalRate = shipment.finalTotalRate || shipment.totalRate;

    if (!transaction && this.state.uiLoaded) {
      this.props.history.push(`${process.env.PUBLIC_URL}/account/orders`);

      return null;
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>
            {`${this.props.t('transactions.my_items')}`}
            {shipment.trackingNumber
              ? `(TRK# ${shipment.trackingNumber})`
              : ''}{' '}
            | Spaceship
          </title>
        </Helmet>
        {transaction ? (
          <React.Fragment>
            {/* <!-- Header --> */}
            <div
              className="transaction-return-container"
              style={{
                backgroundColor: '#f5f5f5',
                margin: '0 auto',
                width: '100%',
                height: '100%',
                maxWidth: `${process.env.REACT_APP_MAX_WIDTH}px`
              }}>
              <div
                style={{
                  paddingBottom: '10px',
                  display:
                    this.state.uiLoaded || this.props.isBusines
                      ? 'block'
                      : 'none'
                }}>
                <div
                  style={{
                    padding: '20px 0',
                    textAlign: 'center',
                    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.2)',
                    backgroundColor: '#fff',
                    position: 'relative',
                    marginBottom: '10px'
                  }}>
                  <div
                    className="back-button"
                    style={{
                      fontSize: '12px',
                      position: 'absolute',
                      top: '0px',
                      left: '0px',
                      padding: '20px 15px',
                      cursor: 'pointer'
                    }}
                    onClick={() => {
                      if (this.props.handleBusinessStep) {
                        this.props.handleBusinessStep(ORDER_HOLD);
                      } else {
                        this.props.history.push(
                          `${process.env.PUBLIC_URL}/account/orders/adjustment/${transaction.ref}`
                        );
                      }
                    }}>
                    <FontAwesomeIcon icon="angle-left" />
                  </div>
                  <TransactionCardTitle className="transaction-detail-title buttonTheme-color">
                    {`${this.props.t('confirmReturn.title')} `}
                  </TransactionCardTitle>
                  <div style={{ fontSize: '12px' }}>
                    <div
                      style={{ display: 'inline-block', paddingRight: '10px' }}>
                      {helpers.responsiveImage(
                        helpers.getCarrierImage(
                          shipment.carrierService.carrier
                        ),
                        helpers.getCarrierText(shipment.carrierService.carrier),
                        helpers.getCarrierImageWidth(
                          shipment.carrierService.carrier,
                          0.8
                        )
                      )}
                    </div>
                    <span style={{ verticalAlign: 'middle' }}>
                      {get(shipment.carrierService.name, this.props.t('key'))}
                    </span>
                  </div>
                  <div
                    style={{
                      fontSize: '20px',
                      fontWeight: 700,
                      padding: '7px 0 5px'
                    }}>
                    {get(
                      countriesData[shipment.fromAddress.country],
                      `name.${this.props.t('key')}`
                    )}
                    <img
                      src={ImagePlane}
                      style={{
                        width: '31.3px',
                        paddingBottom: '2px',
                        margin: '0 6px'
                      }}
                      alt=""
                    />
                    {get(
                      countriesData[shipment.toAddress.country],
                      `name.${this.props.t('key')}`
                    )}
                  </div>
                  <br />
                  <div>
                    <div style={{ fontSize: '12px' }}>
                      {this.props.t('finish.tracking_link')}
                      <a
                        style={{ color: '#9900A5' }}
                        href={helpers.getCarrierTrackingUrl(
                          shipment.carrierService.carrier,
                          shipment.trackingNumber
                        )}
                        className="buttonTheme-color"
                        target="_blank"
                        rel="noopener noreferrer">
                        {shipment.trackingNumber}{' '}
                        <FontAwesomeIcon icon="angle-right" />
                      </a>
                    </div>
                  </div>
                </div>
                {/* <!-- End Header --> */}
                <TransactionReturnContent
                  shipment={shipment}
                  transaction={transaction}
                />
              </div>
              {get(transaction, 'status') === TRANSACTION_HOLD ? (
                <>
                  <div
                    className="actions-btn-group"
                    style={{ paddingBottom: '10px', textAlign: 'center' }}>
                    <StyledButton
                      type="primary"
                      shadow="true"
                      width={201}
                      onClick={() => {
                        this.handleSubmitClick('return');
                      }}
                      loading={this.state.loading}>
                      {this.props.t('confirmReturn.button')}
                    </StyledButton>
                  </div>
                </>
              ) : null}
              <PushUpDrawer
                containerClasses={
                  this.props.data ? 'business-adjustment-drawer' : ''
                }
                visible={this.state.drawerVisible}
                onClose={this.setDrawerVisible}
                title={this.props.t('confirmReturn.returnSuccess')}
                subTitle={this.props.t('confirmReturn.returnSubTitle')}
                btnTitle={this.props.t('confirmAdjustment.backToShipment')}
                btnClick={this.handleSuccessClick}
              />
            </div>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  getTransactionsRequest,
  confirmAdjustmentRequest
};

const mapStateToProps = state => {
  return {
    user: state.auth.user,
    authRequestSuccess: state.auth.authRequestSuccess,
    uiLoading: !!state.users.loading,
    transactions: get(state, 'users.transactions.data') || false,
    confirmAdjustmentSuccess: state.shipments.confirmAdjustmentSuccess || false,
    confirmAdjustmentLoading: !!state.shipments.loading,
    countries: state.shipments.countries || countries
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(TransactionReturn))
);
